import * as React from "react";
import { useContext } from "react";
import { WeekModuleOption } from "burde";
// todo - add type defs for this object
const ConfigurationContext = React.createContext<any>({});

const useConfiguration = (): any => useContext<any>(ConfigurationContext);

const useAvailableWeekModuleOptions = (): Array<WeekModuleOption> => {
    const conf = useConfiguration();

    return conf.weekModuleOptions
        .filter((x: WeekModuleOption) => x.inactive === false)
        .map((option: WeekModuleOption) => ({
            ...option,
            value: option.type,
        }));
};

export {
    ConfigurationContext,
    useConfiguration,
    useAvailableWeekModuleOptions,
};
